export const tableHeaderValues = [
    { text: 'Invoice', key: 'invoiceName', allowSort: true },
    { text: 'Release', key: 'releaseName', allowSort: true },
    { text: 'Sales Order', key: 'salesOrderName', allowSort: true },
    { text: 'Customer PO', key: 'customerPoNumber', allowSort: true },
    { text: 'Assigned To', key: 'assignedToName', allowSort: true },
    { text: 'Created Date', key: 'createdDateSort', allowSort: true },
    { text: 'Status', key: 'statusLabel', allowSort: true },
    { text: 'Customer', key: 'customerName', allowSort: true },
    { text: 'Contact', key: 'contactName', allowSort: true },
    { text: 'RMA Total', key: 'rmaTotal', allowSort: true },
    { text: 'Review', key: 'review', allowSort: false },
];

export const historyTableHeaderValues = [
    { text: 'Invoice', key: 'invoiceName', allowSort: true },
    { text: 'Release', key: 'releaseName', allowSort: true },
    { text: 'Sales Order', key: 'salesOrderName', allowSort: true },
    { text: 'Customer PO', key: 'customerPoNumber', allowSort: true },
    { text: 'Assigned To', key: 'assignedToName', allowSort: true },
    { text: 'Created Date', key: 'createdDateSort', allowSort: true },
    { text: 'Status', key: 'statusLabel', allowSort: true },
    { text: 'RMA #', key: 'rmaNumber', allowSort: true },
    { text: 'RMA Status', key: 'rmaStatus', allowSort: true },
    { text: 'RMA Created Date', key: 'rmaCreatedDateSort', allowSort: true },
    { text: 'RMA Expiration Date', key: 'rmaExpirationDateSort', allowSort: true },
    { text: 'Customer', key: 'customerName', allowSort: true },
    { text: 'Contact', key: 'contactName', allowSort: true },
    { text: 'RMA Total', key: 'rmaTotal', allowSort: true },
    { text: 'View', key: 'view', allowSort: false },
];

export const defaultArrowDirections = {
    invoiceName: { direction: null },
    releaseName: { direction: null },
    salesOrderName: { direction: null },
    customerPoNumber: { direction: null },
    assignedToName: { direction: null },
    createdDateSort: { direction: 'desc' },
    statusLabel: { direction: null },
    rmaNumber: { direction: null },
    rmaStatus: { direction: null },
    rmaCreatedDateSort: { direction: null },
    rmaExpirationDateSort: { direction: null },
    customerName: { direction: null },
    contactName: { direction: null },
    rmaTotal: { direction: null },
};

export const rmaHistoryFilterTypes = {
    APPROVED: 'Approved',
    DENIED: 'Denied',
};

export const rmaHistoryRmaStatusFilterTypes = {
    NEW: 'New',
    APPROVED: 'Approved',
    RECEIVED: 'Received',
    COMPLETE: 'Complete',
    CANCELLED: 'Cancelled',
    NA: 'N/A',
};
